import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  DeleteSweepOutlined as DeleteSweepIcon,
  LightbulbOutlined as LightbulbIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';

interface CopilotHeaderProps {
  isActivating: boolean;
  setIsOpen: (open: boolean) => void;
  onClearChat: () => void;
  hasMessages: boolean;
}

export const CopilotHeader: React.FC<CopilotHeaderProps> = React.memo(
  ({ isActivating: _isActivating, setIsOpen, onClearChat, hasMessages }) => {
    return (
      <Box
        className="ai-panel-header"
        sx={{
          height: 60,
          padding: '0 20px',
          borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'linear-gradient(135deg, #FFFFFF 0%, rgba(25, 118, 210, 0.08) 100%)',
          flexShrink: 0,
        }}
      >
        <Box
          className="ai-header-title"
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontWeight: 700,
            fontSize: '14px',
            color: 'primary.main',
          }}
        >
          <LightbulbIcon sx={{ fontSize: 18 }} />
          LOGIX Copilot
        </Box>
        <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
          <Tooltip title="Clear Chat messages">
            <span>
              <IconButton
                size="small"
                onClick={onClearChat}
                disabled={!hasMessages}
                aria-label="Clear chat messages"
                sx={{
                  color: '#757575',
                  '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
                }}
              >
                <DeleteSweepIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </span>
          </Tooltip>
          <IconButton
            size="small"
            onClick={() => setIsOpen(false)}
            aria-label="Close copilot panel"
            sx={{
              color: '#757575',
              '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
            }}
          >
            <ChevronRightIcon sx={{ fontSize: 20 }} />
          </IconButton>
        </Box>
      </Box>
    );
  },
);

CopilotHeader.displayName = 'CopilotHeader';
